import script from "./ChoseUserIdentify.vue?vue&type=script&lang=ts&setup=true"
export * from "./ChoseUserIdentify.vue?vue&type=script&lang=ts&setup=true"

import "./ChoseUserIdentify.vue?vue&type=style&index=0&id=632ddc5b&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-632ddc5b"]])

export default __exports__